const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content picker component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
*/
app.directive('contentPicker', ['Application', 'Authorization', 'ContentIntegrations', 'AccessHelper', function(Application, Authorization, ContentIntegrations, AccessHelper) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      type: '=',
      label: '=',
      data: '=',
      presentationProp: '='
    },
    template: require('../../templates/directives/content-picker.html'),
    controller: ['$scope', function ($scope) {

      var self = this;
      self.features = Application.features.flags();
      self.imported_content =  self.features.udemy || self.features.linkedin_learning || self.features.enable_masterclass || false;



      self.allowed = {
        articles: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'articles_create']], ['admin', 'creator', 'collaborator']),
        videos: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'videos_create']], ['admin', 'creator', 'collaborator']),
        files: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'files_create']], ['admin', 'creator', 'collaborator']),
        tracks: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'tracks_create']], ['admin', 'creator', 'collaborator']),
        presentations: self.features.presentations && AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'presentations_create']], ['admin', 'creator', 'collaborator']),
        courses: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'tracks_create']], ['admin', 'creator', 'collaborator']) || (self.imported_content && AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'imported_content_create']], ['admin', 'creator', 'collaborator'])),
        workshops: self.features.workshops && AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'workshops_create']], ['admin', 'creator', 'collaborator']),
        scorm: self.features.scorm && AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'scorm_create']], ['admin', 'creator', 'collaborator']),
        add: AccessHelper.isAllowed(['admin', 'users', 'add'], null, ['admin']),
        bulk_add: AccessHelper.isAllowed(['admin', 'users', 'bulk_add'], null, ['admin'])
      };

      self.showContentButton = AccessHelper.allowGeneralActivity('createContent', ['admin', 'creator', 'collaborator']);

      self.setPresentation = function(item) {
        $scope.presentationProp = item;
      };

      self.init = function(){

        self.showingPicker = false;
        self.subtype = '';
        self.multipleLearning = false;
        if (Authorization.getAuthToken().company.udemy || Authorization.getAuthToken().company.linkedin_learning || self.features.enable_masterclass) {
          ContentIntegrations.existing().$promise
          .then(function(results) {
            if (!results || !results.integrations || !results.integrations.length) {
              return;
            }
            self.multipleLearning = true;
          });
        }

        // set type
        if($scope.type){
          self.type = $scope.type;
        } else {
          self.type = 'default';
        }

        if($scope.data){
          self.data = $scope.data;
        }

        // set label
        if ($scope.label){
          self.label = $scope.label;
        }  else if( $scope.type === 'user') {
          self.label = 'contentPicker.addUsers';
        } else {
          self.label = 'contentPicker.addContent';
        }


      };

      self.init();

    }],
    controllerAs: 'picker'
  };
}]);
